// Reading the `hintsSeenJSON` setting, which records which one-time hints the person has already
// dismissed, with no Angular in it so it can be tested (#5191).

/**
 * The hints-seen map stored in `json`, or an empty map when nothing is stored or the stored value
 * is damaged.
 *
 * A damaged value is text that is not JSON, or JSON that is not an object (`null` parses fine,
 * and indexing it throws). Either way the person simply sees their hints again, and the next hint
 * they dismiss overwrites the value with a good one. The damage goes to `reportDamaged`, so a
 * future debugger can see that it happened.
 */
export function parseHintsSeen(json: string, reportDamaged: (err: unknown) => void): Record<string, boolean> {
  if (json === '') return {};
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch (err) {
    reportDamaged(err);
    return {};
  }
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    const found = parsed === null ? 'null' : Array.isArray(parsed) ? 'an array' : typeof parsed;
    reportDamaged(new Error(`hintsSeenJSON holds ${found}, not an object`));
    return {};
  }
  return parsed as Record<string, boolean>;
}
